import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      business: 'Electronics Store, Mumbai',
      rating: 5,
      text: 'We collected 200+ WhatsApp contacts in just 2 weeks! Now we send offers directly and our repeat sales increased by 40%. Best investment for our store.',
      avatar: 'RK'
    },
    {
      name: 'Priya Sharma',
      business: 'Beauty Salon, Delhi',
      rating: 5,
      text: 'Setup was incredibly easy. Customers love how quick it is to connect. We now send appointment reminders and special offers. Our booking rate doubled!',
      avatar: 'PS'
    },
    {
      name: 'Amit Patel',
      business: 'Restaurant, Bangalore',
      rating: 5,
      text: 'Game changer for our restaurant! We collect feedback, send menu updates, and offer discounts to regulars. Customer engagement is through the roof!',
      avatar: 'AP'
    },
    {
      name: 'Sneha Reddy',
      business: 'Boutique Store, Hyderabad',
      rating: 5,
      text: 'The QR stand looks so professional on our counter. Customers scan it without us even asking. We have built a database of 500+ customers in 3 months!',
      avatar: 'SR'
    },
    {
      name: 'Vikram Singh',
      business: 'Gym & Fitness Center, Pune',
      rating: 5,
      text: 'Perfect for our gym! We send workout tips, class schedules, and renewal reminders. Member retention improved by 35%. Highly recommended!',
      avatar: 'VS'
    },
    {
      name: 'Meera Joshi',
      business: 'Medical Clinic, Chennai',
      rating: 5,
      text: 'Patients can easily save our number and reach us on WhatsApp. We send health tips and appointment confirmations. Very professional solution!',
      avatar: 'MJ'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            What Business Owners Are Saying
          </h2>
          <p className="text-xl text-gray-300">
            Join 500+ businesses already growing with MPillar AIQR Kit
          </p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-2xl">★</span>
              ))}
            </div>
            <span className="text-lg font-semibold">4.9/5.0 from 500+ reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center font-bold text-white">
                  {testimonial.avatar}
                </div>
                <div>
                  <h4 className="font-bold">{testimonial.name}</h4>
                  <p className="text-sm text-gray-300">{testimonial.business}</p>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="text-yellow-400">★</span>
                ))}
              </div>
              <p className="text-gray-200 text-sm leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-green-500 text-white px-6 py-3 rounded-full font-semibold">
            ✓ Verified Purchases | ✓ Real Results | ✓ Money-Back Guarantee
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;